require('../step.scss');
require('./cardMobileRechargeStep1.scss');
require('./cardMobileRechargeStep1.override.scss');

const PropTypes = require('prop-types');

//@vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { connect } = require('react-redux');
const OKSelect = require('components/commons/OKSelect/OKSelect');

//@helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

//@constants
const {
    EURO_SYMBOL,
    FIRST_STEP,
    PHONE_NON_NUMERIC_REGEX,
    PHONE_NUMBER_MAX_LENGTH,
    SPAIN_COUNTRY_CODE
} = require('constants/index');

//@actions
const cardMobileRechargeActions = require('actions/cardMobileRecharge');

//@commons
const { InputSafe } = require('commonsComponents/inputSafe');
const OKSliderInput = require('commonsComponents/OKSliderInput');

class CardMobileRechargeStep1 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            mobilePhone: props.immCardMobileRecharge.getIn(['steps', FIRST_STEP, 'mobilePhone'])
        };

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleOperatorChange = this.handleOperatorChange.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleMobilePhoneChange = this.handleMobilePhoneChange.bind(this);
        this.handleMobilePhoneBlur = this.handleMobilePhoneBlur.bind(this);
        this.handleMobilePhoneFocus = this.handleMobilePhoneFocus.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const mobilePhone = nextProps.immCardMobileRecharge.getIn(['steps', FIRST_STEP, 'mobilePhone']);

        this.setState({
            mobilePhone
        });
    }

    formatOperatorDropdownOptions(operatorsList) {
        const operators = [];

        operatorsList.forEach((entry) => {
            operators.push({ value: entry.get('code'), label: entry.get('label') });
        });

        return operators;
    }

    handleAmountChange(amount) {
        this.props.amountChanged(amount);
    }

    handleMobilePhoneBlur(evt) {
        this.props.mobilePhoneChanged(evt.target.value);
    }

    handleMobilePhoneChange(evt) {
        this.setState({
            mobilePhone: evt.target.value.replace(PHONE_NON_NUMERIC_REGEX, "").trim()
        });
    }

    handleMobilePhoneFocus() {
        if (this.state.mobilePhone.includes('*')) {
            this.setState({
                mobilePhone: ''
            });
        }
    }

    handleOperatorChange(evt) {
        this.props.operatorChanged(evt.value, evt.label);
    }

    render() {
        const { immCardMobileRecharge } = this.props;
        const immFirstStep = immCardMobileRecharge.getIn(['steps', FIRST_STEP]);
        const amountOptions = immFirstStep.get('amountRanges');
        const minValue = amountOptions.get(0);
        const maxValue = amountOptions.get(amountOptions.size - 1);
        const minLabel = `${minValue}`;
        const maxLabel = `${maxValue}`;

        const selectedOperatorCode = immFirstStep.get('selectedOperatorCode');
        const selectedAmount = immFirstStep.getIn(['selectedAmount', 'amount']) || minValue;

        const operatorOptions = this.formatOperatorDropdownOptions(immFirstStep.get('operators'));
        const mobilePhoneLabel = formatText('cardMobileRecharge-firstStepMobileInputTitle');
        const mobilePhoneRequiredAlertVisible = immFirstStep.get('mobilePhoneIsDirty') && !immFirstStep.get('mobilePhone');
        const mobilePhoneWrongNumberAlertVisible = immFirstStep.get('mobilePhoneIsDirty') && !immFirstStep.get('isMobilePhoneValid');
        let mobilePhoneErrorMessage;

        if (mobilePhoneRequiredAlertVisible) {
            mobilePhoneErrorMessage = formatText('cardMobileRecharge-requiredFieldMessage');
        } else if (mobilePhoneWrongNumberAlertVisible) {
            mobilePhoneErrorMessage = formatText('cardMobileRecharge-wrongFormatMobilePhoneMessage');
        }

        return (
            <div className="card-mobile-recharge-step">
                <header className="card-mobile-recharge-step__header">
                    <div className="card-mobile-recharge-step__title">
                        <FormattedText value="cardMobileRecharge-firstStepTitle" />
                    </div>
                </header>
                <article className="card-mobile-recharge-step__content">
                    <div className="card-mobile-recharge-step-one__subtitle">
                        <FormattedText value="cardMobileRecharge-firstStepOperatorDropdownTitle" />
                    </div>
                    <div className="card-mobile-recharge-step-one__operator-select">
                        <OKSelect
                            className="card-mobile-recharge-step-one__select"
                            clearable={false}
                            noResultsText={formatText('profile-selectNotFound')}
                            onChange={this.handleOperatorChange}
                            options={operatorOptions}
                            placeholder={formatText('profile-selectPlaceholder')}
                            value={selectedOperatorCode}
                        />
                    </div>
                    <div className="card-mobile-recharge-step-one__subtitle card-mobile-recharge-step-one__subtitle--slider">
                        <FormattedText value="cardMobileRecharge-firstStepAmountDropdownTitle" />
                    </div>
                    <div className="card-mobile-recharge-step-one__slider-container">
                        <div className="card-mobile-recharge-step-one__slider">
                            <OKSliderInput
                                defaultValue={selectedAmount}
                                onChange={this.handleAmountChange}
                                minLabel={minLabel}
                                maxLabel={maxLabel}
                                min={minValue}
                                max={maxValue}
                                marks={amountOptions}
                                unit={EURO_SYMBOL}
                            />
                        </div>
                    </div>
                    <div className="card-mobile-recharge-step-one__subtitle">
                        {mobilePhoneLabel}
                    </div>
                    <div>
                        <div className="card-mobile-recharge-step-one__phone-code-input">
                            <InputSafe
                                disabled={true}
                                name="phoneCode"
                                type="text"
                                value={`+${SPAIN_COUNTRY_CODE}`}
                            />
                        </div>
                        <div className="card-mobile-recharge-step-one__phone-input">
                            <InputSafe
                                maxLength={PHONE_NUMBER_MAX_LENGTH}
                                name="phoneNumber"
                                onBlur={this.handleMobilePhoneBlur}
                                onChange={this.handleMobilePhoneChange}
                                onFocus={this.handleMobilePhoneFocus}
                                type="text"
                                value={this.state.mobilePhone}
                                errorState={mobilePhoneRequiredAlertVisible || mobilePhoneWrongNumberAlertVisible}
                                errorMessage={mobilePhoneErrorMessage}
                            />
                        </div>
                    </div>
                </article>
            </div>
        );
    }
}

CardMobileRechargeStep1.propTypes = {
    immCardMobileRecharge: PropTypes.object,
    operatorChanged: PropTypes.func.isRequired,
    amountChanged: PropTypes.func.isRequired,
    mobilePhoneChanged: PropTypes.func.isRequired,
    setUpStep: PropTypes.func.isRequired
};

module.exports.constructor = CardMobileRechargeStep1;
module.exports.CardMobileRechargeStep1 = connect(null, {
    operatorChanged: cardMobileRechargeActions.operatorChanged,
    amountChanged: cardMobileRechargeActions.amountChanged,
    mobilePhoneChanged: cardMobileRechargeActions.mobilePhoneChanged
})(CardMobileRechargeStep1);